import { Grid, Typography } from '@mui/material';
import React from 'react';

import { muiStyles } from './styles';
import { TableOverlayProps } from './types';

export const TableOverlay = (props: TableOverlayProps) => {
    const classes = muiStyles(props);

    return (
        <Grid
            className={classes.root}
            container
        >
            <Typography
                data-testid='TableOverlay-text'
                variant='body1'
            >
                {props.text}
            </Typography>
        </Grid>
    );
};